import jqueryValidate from "jquery-validation";
import * as bootstrap from 'bootstrap';

var min_load = 500;
var ajaxTime = 0;
var wait = 0;
var totalTime = 0;

const global_func = require('./globals.js');
var lookup_ajax_running = false;
var ajax_timer=false;

jQuery(document).ready(function($) {
  if(document.getElementById('editBookingModal')) {
    window.editBookingModal = Modal.getOrCreateInstance(document.querySelector('#editBookingModal'), {
      keyboard: false,
      backdrop: 'static',
    });
  }

  if(document.getElementById('rotaCloudModal')) {
    window.rotaCloudModal = Modal.getOrCreateInstance(document.querySelector('#rotaCloudModal'), {
      keyboard: true,
      backdrop: 'static',
    });

    $('#rotaCloudModal').on('shown.bs.modal', function (e) {
      $('#rotaCloudModal').find('input[type="text"]').first().trigger('focus');
    });
  }

  if(document.getElementById('searchBookingModal')) {
    window.searchBookingModal = Modal.getOrCreateInstance(document.querySelector('#searchBookingModal'), {
      keyboard: false,
      backdrop: 'static',
    });
  }

  if(document.getElementById('moveBookingModal')) {
    window.moveBookingModal = Modal.getOrCreateInstance(document.querySelector('#moveBookingModal'), {
      keyboard: false,
      backdrop: 'static',
    });
  }

  if(document.getElementById('confirmEditBookingModal')) {
    window.confirmEditBookingModal = Modal.getOrCreateInstance(document.querySelector('#confirmEditBookingModal'), {
      keyboard: false,
      backdrop: 'static',
    });
  }

  if(document.getElementById('chargeCardModal')) {
    window.chargeCardModal = Modal.getOrCreateInstance(document.querySelector('#chargeCardModal'), {
      keyboard: false,
      backdrop: 'static',
    });
  }

  if(document.getElementById('deletePaymentModal')) {
    window.deletePaymentModal = Modal.getOrCreateInstance(document.querySelector('#deletePaymentModal'), {
      keyboard: false,
      backdrop: 'static',
    });

    $('#deletePaymentModal').on('hide.bs.modal', function(event) {
      $('#deletePaymentModal input[name="booking_id"]').val('');
      $('#deletePaymentModal input[name="payment_id"]').val('');
      $('#deletePaymentModal .delete-payment-error-hold').html('');
      $('#deletePaymentModal form').trigger('reset');
    });
  }

  if(document.getElementById('resendPaymentModal')) {
    window.resendPaymentModal = Modal.getOrCreateInstance(document.querySelector('#resendPaymentModal'), {
      keyboard: false,
      backdrop: 'static',
    });

    $('#resendPaymentModal').on('hide.bs.modal', function(event) {
      $('#resendPaymentModal input[name="booking_id"]').val('');
      $('#resendPaymentModal input[name="payment_id"]').val('');
      $('#resendPaymentModal .resend-payment-error-hold').html('');
      $('#resendPaymentModal form').trigger('reset');
    });
  }

  $('body').on('click', '#editBookingModal .delete-payment-button', function(event) {
    event.preventDefault();
    if(window.deletePaymentModal) {
      window.deletePaymentModal.show();
      var booking_id = $(this).closest('.edit-booking-form').find('input[name="booking_id"]').val();
      var payment_id = $(this).attr('data-payment-id');
      var is_refund = $(this).attr('data-is-refund');
      $('#deletePaymentModal input[name="booking_id"]').val(booking_id);
      $('#deletePaymentModal input[name="payment_id"]').val(payment_id);

      if(is_refund=='true') {
        $('#deletePaymentModal .refund-text-hold').show();
        $('#deletePaymentModal .delete-text-hold').hide();
      } else {
        $('#deletePaymentModal .refund-text-hold').hide();
        $('#deletePaymentModal .delete-text-hold').show();
      }
    }
  });

  $('body').on('click', '#editBookingModal .resend-payment-link-button', function(event) {
    event.preventDefault();
    if(window.resendPaymentModal) {
      window.resendPaymentModal.show();
      var booking_id = $(this).closest('.edit-booking-form').find('input[name="booking_id"]').val();
      var payment_id = $(this).attr('data-payment-id');
      $('#resendPaymentModal input[name="booking_id"]').val(booking_id);
      $('#resendPaymentModal input[name="payment_id"]').val(payment_id);
    }
  });

  if(document.getElementById('cancelBookingModal')) {
    window.cancelBookingModal = Modal.getOrCreateInstance(document.querySelector('#cancelBookingModal'), {
      keyboard: false,
      backdrop: 'static',
    });

    $('#cancelBookingModal').on('hide.bs.modal', function(event) {
      $('#cancelBookingModal input[name="booking_id"]').val('');
      $('#cancelBookingModal .cancel-booking-error-hold').html('');
      $('#cancelBookingModal form').trigger('reset');
    });
  }

  if(document.getElementById('reinstateBookingModal')) {
    window.reinstateBookingModal = Modal.getOrCreateInstance(document.querySelector('#reinstateBookingModal'), {
      keyboard: false,
    });

    $('#reinstateBookingModal').on('hide.bs.modal', function(event) {
      $('#reinstateBookingModal input[name="booking_id"]').val('');
      $('#reinstateBookingModal form').trigger('reset');
    });
  }

  $('body').on('click', '.diary-hold .bookings .booking>div:not(.covers)', function(event) {
    event.preventDefault();
    if(window.editBookingModal) {
      window.editBookingModal.show();
      if(window.rotaCloudModal) {
        window.rotaCloudModal.show();
      }
      get_booking($(this).parent().attr('data-booking-id'));
    }
  });

  $('body').on('click', '.booking-list-hold a.diary-edit', function(event) {
    event.preventDefault();
    if(window.editBookingModal) {
      window.editBookingModal.show();
      if(window.rotaCloudModal) {
        window.rotaCloudModal.show();
      }
      get_booking($(this).attr('data-booking-id'));
    }
  });

  $('body').on('click', '.search-results-hold a.diary-edit', function(event) {
    event.preventDefault();
    if(window.searchBookingModal) {
      window.searchBookingModal.hide();
    }
    if(window.editBookingModal) {
      window.editBookingModal.show();
      if(window.rotaCloudModal) {
        window.rotaCloudModal.show();
      }
      get_booking($(this).attr('data-booking-id'), true);
    }
  });

  $('body').on('click', '.booking-search-button', function(event) {
    event.preventDefault();
    if(window.searchBookingModal) {
      $('#searchBookingModal form').trigger('reset').trigger('submit');
      $('#searchBookingModal form').find('input[type="text"]').first().trigger('focus');
      window.searchBookingModal.show();
    }
  });

  $('body').on('click', '.charge-card-button', function(event) {
    event.preventDefault();
    if(window.chargeCardModal) {
      $('#chargeCardModal .charge-booking-error-hold').html('');
      $('#chargeCardModal form').trigger('reset');
      $('#chargeCardModal form input[name="setup_intent"]').val($(this).attr('data-setup-intent-id'));
      $('#chargeCardModal form input[name="booking_id"]').val($(this).attr('data-booking-id'));
      window.chargeCardModal.show();
    }
  });

  $('body').on('click', '.confirm-amount-button', function(event) {
    event.preventDefault();
    var booking_form = $(this).closest('form.edit-booking-form');
    if($(booking_form).find('input[name="deposit_due"]').val() > 0 && $(booking_form).find('select[name="payment_type"]').val()=='card') {
      $('#editBookingModal').trigger('newPaymentIntent', booking_form);
      $('#editBookingModal').find('.edit-booking-new-payment-hold').show();
      $('#editBookingModal').find('.new-payment-section').hide();
    } if($(booking_form).find('input[name="deposit_due"]').val() > 0 && ($(booking_form).find('select[name="payment_type"]').val()=='third_party' ||  $(booking_form).find('select[name="payment_type"]').val()=='link' ||  $(booking_form).find('select[name="payment_type"]').val()=='cash'  ||  $(booking_form).find('select[name="payment_type"]').val()=='refund' ) ) {
      $('#editBookingModal').find('.new-payment-section').hide();
      $('#editBookingModal').trigger('newPaymentAdmin', booking_form);
    }
  });

  $('body').on('change', '.edit-booking-form input[name="promotion"], .edit-booking-form input[name="adults"],  .edit-booking-form input[name="children"],  .edit-booking-form input[name="infants"],  .edit-booking-form input[name="area_hire"]', function(event) {
    get_deposit_due($(this).closest("form"));
  });

  $('body').on('click', '.edit-booking-form .cancel-booking-link', function(event) {
    event.preventDefault();
    var booking_id = $(this).closest("form").find('input[name="booking_id"]').val();
    if(booking_id) {
      $('#cancelBookingModal input[name="booking_id"]').val(booking_id);
      window.cancelBookingModal.show();
    }
  });

  $('body').on('click', '#cancelled-list-results a.reinstate-booking-link, .edit-booking-form a.reinstate-booking-link', function(event) {
    event.preventDefault();
    var booking_id = $(this).attr('data-booking-id');
    if(booking_id) {
      $('#reinstateBookingModal input[name="booking_id"]').val(booking_id);
      window.reinstateBookingModal.show();
    }
  });

  $('body').on('submit', '.cancel-booking-form', function(event) {
    event.preventDefault();
    cancel_booking(this)
  });

  $('body').on('submit', '.reinstate-booking-form', function(event) {
    event.preventDefault();
    reinstate_booking(this)
  });

  $('body').on('submit', '.charge-card-form', function(event) {
    event.preventDefault();
    charge_card(this);
  });

  $('body').on('submit', '.delete-payment-form', function(event) {
    event.preventDefault();
    delete_payment(this);
  });

  $('body').on('submit', '.resend-payment-form', function(event) {
    event.preventDefault();
    resend_payment(this);
  });

  $('body').on('reload_booking', '#editBookingModal', function(event, booking_id) {
    window.editBookingModal.show();
    get_payments_for_booking(booking_id);
    $('#editBookingModal .modal-body').scrollTop(0);
  });

  $('body').on('keyup submit', '.search-booking-form input[name="search"], .search-booking-form', function(event) {
    event.preventDefault();
    var form = $(this).closest("form");
    if(!lookup_ajax_running) {
      search_bookings(form);
    } else {
      if(ajax_timer) {
        clearTimeout(ajax_timer);
      }
      ajax_timer = setTimeout(check_search, 1000, form)
    }
  });

  $('body').on('keyup', 'input.lookup-customer', function(event) {
    event.preventDefault();
    var form = $(this).closest("form");
    var do_lookup = false;
    //only do lookup if one or more fields empty
    $(form).find('input.lookup-customer').each(function(index, el) {
      if($(el).val() === "") {
        do_lookup = true;
      }
    });
    if(!lookup_ajax_running && do_lookup) {
      lookup_customer(form);
    } else if(do_lookup) {
      if(ajax_timer) {
        clearTimeout(ajax_timer);
      }
      ajax_timer = setTimeout(check_lookup, 1000, form)
    }
  });

  $('body').on('click', 'button.send-booking-email', function(event) {
    event.preventDefault();
    var form = $(this).closest("form");
    send_booking_email(form);
  });

  $('body').on('click', '.customer-lookup-results .customer', function(event) {
    event.preventDefault();
    var form = $(this).closest("form");
    var customer_data = $(this).data('customer');
    if(customer_data.first_name) {
      $(form).find('input[name="first_name"]').val(customer_data.first_name).trigger('change');
    }
    if(customer_data.last_name) {
      $(form).find('input[name="last_name"]').val(customer_data.last_name).trigger('change');;
    }
    if(customer_data.email) {
      $(form).find('input[name="email"]').val(customer_data.email);
    }
    if(customer_data.phone_number) {
      $(form).find('input[name="phone"]').val(customer_data.phone_number);
    }
    $(form).find('.customer-lookup-results').html('');
  });

  $('body').on('change', 'select[name="filter_promotions"], select[name="filter_areas"]', function(event) {
    // filter_booking_list();
  });

  $('body').on('click', '#show-filter-button', function(event) {
    event.preventDefault();
    $('.filter-list').slideToggle(400, function() {
        // Trigger the resize event after the slideToggle animation completes
        $(window).trigger('resize');
    });
  });

  $('body').on('click', '#filter-button', function(event) {
    $('.get-diary-form').trigger('submit');
  });


  $('body').on('click', '#clear-filter-button', function(event) {
    event.preventDefault();
    $('.get-diary-form').find('select[name="filter_promotions[]"]').val([]).trigger('change');
    $('.get-diary-form').find('select[name="filter_areas[]"]').val([]).trigger('change');
    $('.get-diary-form').trigger('submit');
  });
  

  $('.get-diary-form').on('diary-loaded', function(event) {
    $('body').find('select[name="filter_promotions[]"]').select2({
      theme: "bootstrap-5",
    });
    $('body').find('select[name="filter_areas[]"]').select2({
      theme: "bootstrap-5",
    });
  });

  
});



function filter_booking_list() {
  // Get the current values selected in both dropdowns
  var selectedPromotions = $('select[name="filter_promotions"]').val() || [];
  var selectedAreas = $('select[name="filter_areas"]').val() || [];

  // Consider "Show all" if selected array is empty or contains only an empty string
  var showAllPromotions = selectedPromotions.length === 0 || (selectedPromotions.length === 1 && selectedPromotions[0] === "");
  var showAllAreas = selectedAreas.length === 0 || (selectedAreas.length === 1 && selectedAreas[0] === "");

  updatePrintButtonUrls(showAllPromotions ? null : selectedPromotions, showAllAreas ? null : selectedAreas);

  // Filter table rows based on selected values
  $('body').find('.booking-list-hold table tbody tr').each(function() {
      var row = $(this);
      var promotion = row.data('booking-promotion');
      var areas = JSON.parse(row.attr('data-booking-area') || '[]'); // Parse JSON, default to empty array if null

      // Check if the current row should be displayed
      var promotionMatch = showAllPromotions || selectedPromotions.includes(promotion);
      var areaMatch = showAllAreas || areas.some(area => selectedAreas.includes(area));

      if (promotionMatch && areaMatch) {
          row.show();
      } else {
          row.hide();
      }
  });
}

function updatePrintButtonUrls(promotions, areas) {
    var baseUrlList = $('body').find('a.print-bookings').first().attr('data-base-url');
    var baseUrlCards = $('body').find('a.print-bookings-cards').first().attr('data-base-url');

    // Build query parameters based on selected options
    var params = [];
    if (promotions) {
        params.push('promotions=' + encodeURIComponent(promotions.join(',')));
    }
    if (areas) {
        params.push('areas=' + encodeURIComponent(areas.join(',')));
    }
    var paramString = params.length > 0 ? '&' + params.join('&') : '';

    // Update the href for both print buttons
    $('body').find('a.print-bookings').attr('href', baseUrlList + paramString);
    $('body').find('a.print-bookings-cards').attr('href', baseUrlCards + paramString);
}

function check_lookup(form) {
    if(!lookup_ajax_running) {
      lookup_customer(form);
    } else {
      if(ajax_timer) {
        clearTimeout(ajax_timer);
      }
      ajax_timer = setTimeout(check_lookup, 1000, $(this).closest("form"))
    }
}

function check_search(form) {
    if(!lookup_ajax_running) {
      search_bookings(form);
    } else {
      if(ajax_timer) {
        clearTimeout(ajax_timer);
      }
      ajax_timer = setTimeout(check_lookup, 1000, $(this).closest("form"))
    }
}

function update_booking_payments_info(form) {
  vm.paymentsTotal($(form).find('input[name="payments_total"]').first().val());
  vm.paymentsTotalText(global_func.pence_to_pounds(vm.paymentsTotal()));
  vm.bookingDepositDue($(form).find('input[name="booking_deposit_due"]').first().val());
  vm.bookingDepositDueText(global_func.pence_to_pounds(vm.bookingDepositDue()));
}

function get_deposit_due(form) {
  let data = {};

  data['_token'] = $(form).find('input[name="_token"]').val();
  data['promotion'] = $(form).find('input[name="promotion"]:checked').val();
  data['adults'] = $(form).find('input[name="adults"]').val();
  data['children'] = $(form).find('input[name="children"]').val();
  data['infants'] = $(form).find('input[name="infants"]').val();
  data['highchairs'] = $(form).find('input[name="highchairs"]').val();
  data['booking_id'] = $(form).find('input[name="booking_id"]').val();

  if( $(form).find('input[name="area_hire"]:checked').length ) {
    data['area_hire'] = $(form).find('input[name="area_hire"]:checked').val();
  }

  $.ajax({
    url: '/get-deposit-due',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.deposit) {
        $(form).find('input[name="booking_deposit_due"]').val(response.deposit);
        update_booking_payments_info(form);
      }
    },
    error: function(response) {
      $('#bookingErrorModal .error-modal-hold').html('');
      window.bookingErrorModal.show();
    }
  });
}

function get_booking(booking_id, reload=false, nav_tab=false) {
  let data = {};
  data['id'] = booking_id;
  $('#editBookingModal .booking-details').html($('.ajax-loader-hold .ajax-loader').clone());
  
  wait = 0;
  ajaxTime = new Date().getTime();

  $.ajax({
    url: '/get-booking',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      totalTime = new Date().getTime()-ajaxTime;
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        alert(response.message);
      }
      if(response.response_html) {
        if(totalTime < min_load) {
          wait = min_load-totalTime;
        }
        
        setTimeout(function() {
          ko.cleanNode($('body').find('#editBookingModal .booking-details')[0]);
          $('#editBookingModal .booking-details').html(response.response_html);
          if(reload) {
            $('.get-diary-form input[name="date"]').val(response.date).trigger('change');
          }
          $('#editBookingModal').trigger('bookingLoading');
          update_booking_payments_info($('body').find('#editBookingModal'));
          ko.applyBindings(vm, $('body').find('#editBookingModal .booking-details')[0]);
          $('#editBookingModal').trigger('bookingLoaded');
        }, wait);
   
      }
    },
    error: function(response) {
      totalTime = new Date().getTime()-ajaxTime;
      if(totalTime < min_load) {
        wait = min_load-totalTime;
      }
      setTimeout(function() {
        $('#editBookingModal .booking-details').html('');
        if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
          $('.booking-form .locations-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
        }
      }, wait);
    }
  });
}

function lookup_customer(form) {
  let data = {};
  data['first_name'] = $(form).find('input[name="first_name"]').val();
  data['last_name'] = $(form).find('input[name="last_name"]').val();
  data['email'] = $(form).find('input[name="email"]').val();
  data['phone_number'] = $(form).find('input[name="phone"]').val();
  lookup_ajax_running = true;

  $.ajax({
    url: '/customer/lookup',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      $('.customer-lookup-results').html('');
      if(response.customers) {
        $('.customer-lookup-results').html(response.customers);
      }
      lookup_ajax_running = false;
    },
    error: function(response) {
      lookup_ajax_running = false;
    }
  });
}

function search_bookings(form) {
  let data = {};
  data['search'] = $(form).find('input[name="search"]').val();
  lookup_ajax_running = true;

  $.ajax({
    url: '/bookings/search',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      $('.search-results-hold').html('');
      if(response.bookings) {
        $('.search-results-hold').html(response.bookings);
      }
      lookup_ajax_running = false;
    },
    error: function(response) {
      $('.search-results-hold').html('');
      lookup_ajax_running = false;
    }
  });
}

function send_booking_email(form) {
  let data = {};
  data['booking_id'] = $(form).find('input[name="booking_id"]').val();
  var old_html = $(form).find('.tools-hold').html();
  $(form).find('.tools-hold').html($('.ajax-loader-hold .ajax-loader').clone());
  $(form).find('.tools-success').html('');
  $(form).find('.tools-success').hide();

  $.ajax({
    url: '/bookings/customer-email',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {

      if(response.success_html) {
        $(form).find('.tools-success').html(response.success_html);
        $(form).find('.tools-success').show();
      }

      if(response.success) {
        $(form).find('.tools-hold').html(old_html);
      }
    },
    error: function(response) {
      $(form).find('.tools-hold').html(old_html);
      window.bookingErrorModal.show();
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        $('#bookingErrorModal .error-modal-hold').html('<div class="alert alert-danger"><ul></ul></div>');
        $.each(response.responseJSON.errors, function(index, val) {
          $('#bookingErrorModal .error-modal-hold').find('ul').append('<li>'+val+'</li>');
        });
        
      }else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#bookingErrorModal .error-modal-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
    }
  });
}

function cancel_booking(form) {
  $('#cancelBookingModal .cancel-booking-details').append($('.ajax-loader-hold .ajax-loader').clone());
  $('#cancelBookingModal .cancel-booking-details form').hide();

  $.ajax({
    url: '/bookings/cancel/'+$(form).find('input[name="booking_id"]').val(),
    method: 'POST',
    data: $(form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#cancelBookingModal .cancel-booking-details form').show();
      $('#cancelBookingModal .cancel-booking-details').find('.ajax-loader').remove();
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.success) {
        window.cancelBookingModal.hide();
        window.editBookingModal.hide();
        $('#nav-cancelled-tab button').trigger('click');
        $('.get-diary-form').trigger('submit');
      }
    },
    error: function(response) {
      $('#cancelBookingModal .cancel-booking-details form').show();
      $('#cancelBookingModal .cancel-booking-details').find('.ajax-loader').remove();
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        $('#cancelBookingModal .cancel-booking-error-hold').html('<div class="alert alert-danger"><ul></ul></div>');
        $.each(response.responseJSON.errors, function(index, val) {
          $('#cancelBookingModal .cancel-booking-error-hold').find('ul').append('<li>'+val+'</li>');
        });
        
      }else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#cancelBookingModal .cancel-booking-error-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
    }
  });
}

function reinstate_booking(form) {
  $('#reinstateBookingModal .reinstate-booking-details').append($('.ajax-loader-hold .ajax-loader').clone());
  $('#reinstateBookingModal .reinstate-booking-details form').hide();
  var booking_id = $(form).find('input[name="booking_id"]').val()
  $.ajax({
    url: '/bookings/reinstate/'+booking_id,
    method: 'POST',
    data: $(form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#reinstateBookingModal .reinstate-booking-details form').show();
      $('#reinstateBookingModal .reinstate-booking-details').find('.ajax-loader').remove();
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.success) {
        $('#nav-diary-tab button').trigger('click');
        $('.get-diary-form').trigger('submit');
        window.editBookingModal.show();
        get_booking(booking_id);
        window.reinstateBookingModal.hide();
      }
    },
    error: function(response) {
      $('#reinstateBookingModal .reinstate-booking-details form').show();
      $('#reinstateBookingModal .reinstate-booking-details').find('.ajax-loader').remove();
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        $('#reinstateBookingModal .reinstate-booking-error-hold').html('<div class="alert alert-danger"><ul></ul></div>');
        $.each(response.responseJSON.errors, function(index, val) {
          $('#reinstateBookingModal .reinstate-booking-error-hold').find('ul').append('<li>'+val+'</li>');
        });
        
      }else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#reinstateBookingModal .reinstate-booking-error-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
    }
  });
}

function delete_payment(form) {
  $('#deletePaymentModal .delete-payment-details').append($('.ajax-loader-hold .ajax-loader').clone());
  $('#deletePaymentModal .delete-payment-details form').hide();
  var booking_id = $(form).find('input[name="booking_id"]').val()
  var payment_id = $(form).find('input[name="booking_id"]').val()
  $.ajax({
    url: '/bookings/delete-payment/'+booking_id,
    method: 'POST',
    data: $(form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#deletePaymentModal .delete-payment-details form').show();
      $('#deletePaymentModal .delete-payment-details').find('.ajax-loader').remove();
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.success) {
        get_payments_for_booking(booking_id);
        window.deletePaymentModal.hide();
      }
    },
    error: function(response) {
      $('#deletePaymentModal .delete-payment-details form').show();
      $('#deletePaymentModal .delete-payment-details').find('.ajax-loader').remove();
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        $('#deletePaymentModal .delete-payment-error-hold').html('<div class="alert alert-danger"><ul></ul></div>');
        $.each(response.responseJSON.errors, function(index, val) {
          $('#deletePaymentModal .delete-payment-error-hold').find('ul').append('<li>'+val+'</li>');
        });
        
      }else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#deletePaymentModal .delete-payment-error-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
    }
  });
}

function resend_payment(form) {
  $('#resendPaymentModal .resend-payment-details').append($('.ajax-loader-hold .ajax-loader').clone());
  $('#resendPaymentModal .resend-payment-details form').hide();
  var booking_id = $(form).find('input[name="booking_id"]').val()
  var payment_id = $(form).find('input[name="booking_id"]').val()
  $.ajax({
    url: '/bookings/resend-payment/'+booking_id,
    method: 'POST',
    data: $(form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#resendPaymentModal .resend-payment-details form').show();
      $('#resendPaymentModal .resend-payment-details').find('.ajax-loader').remove();
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.success) {
        get_payments_for_booking(booking_id);
        window.resendPaymentModal.hide();
      }
    },
    error: function(response) {
      $('#resendPaymentModal .resend-payment-details form').show();
      $('#resendPaymentModal .resend-payment-details').find('.ajax-loader').remove();
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        $('#resendPaymentModal .resend-payment-error-hold').html('<div class="alert alert-danger"><ul></ul></div>');
        $.each(response.responseJSON.errors, function(index, val) {
          $('#resendPaymentModal .resend-payment-error-hold').find('ul').append('<li>'+val+'</li>');
        });
        
      }else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#resendPaymentModal .resend-payment-error-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
    }
  });
}

function charge_card(form) {
  $('#chargeCardModal .charge-card-details').append($('.ajax-loader-hold .ajax-loader').clone());
  $('#chargeCardModal .charge-card-details  .form-element').hide();
  var booking_id = $(form).find('input[name="booking_id"]').val();
  $(form).find('.submit-button').prop("disabled", true);
  $.ajax({
    url: '/bookings/charge-card/'+booking_id,
    method: 'POST',
    data: $(form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#chargeCardModal .charge-card-details .form-element').show();
      $('#chargeCardModal .charge-card-details').find('.ajax-loader').remove();
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.success) {
        get_payments_for_booking(booking_id);
        window.chargeCardModal.hide();
      }
      $(form).find('.submit-button').prop("disabled", false);
    },
    error: function(response) {
      $('#chargeCardModal .charge-card-details  .form-element').show();
      $('#chargeCardModal .charge-card-details').find('.ajax-loader').remove();
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        $('#chargeCardModal .charge-booking-error-hold').html('<div class="alert alert-danger"><ul></ul></div>');
        $.each(response.responseJSON.errors, function(index, val) {
          $('#chargeCardModal .charge-booking-error-hold').find('ul').append('<li>'+val+'</li>');
        });
        
      }else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#chargeCardModal .charge-booking-error-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
      $(form).find('.submit-button').prop("disabled", false);
    }
  });
}

function get_payments_for_booking(booking_id) {
  $.ajax({
    url: '/bookings/get-payments/'+booking_id,
    method: 'GET',
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.html) {
        ko.cleanNode($('body').find('#editBookingModal .booking-details')[0]);
        $('#editBookingModal .booking-details #nav-payments .form-hold').first().html(response.html);
        $('#editBookingModal').trigger('bookingLoading');
        update_booking_payments_info($('body').find('#editBookingModal'));
        ko.applyBindings(vm, $('body').find('#editBookingModal .booking-details')[0]);
        $('#editBookingModal').trigger('bookingLoaded');
      }
    },
    error: function(response) {
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        $('#bookingErrorModal .error-modal-hold').html('<div class="alert alert-danger"><ul></ul></div>');
        $.each(response.responseJSON.errors, function(index, val) {
          $('#bookingErrorModal .error-modal-hold').find('ul').append('<li>'+val+'</li>');
        });
        
      }else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#bookingErrorModal .error-modal-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
      window.bookingErrorModal.show();
    }
  });
}
